import styles from '../../styles/style.module.scss';
import appStore from '../../../../assets/images/AppStoreIcon.png';
import languages from '../../../../assets/images/languages.png';
import phone from '../../../../assets/images/phoneVoery.png';

import { Typography } from 'src/onboarding/components/typography-voery/Typography';
import { t } from '@web-solutions/module-localization';

export const AppStoreAppComponent = () => {
  return (
    <>
      <div className={styles.appStoreContainer}>
        <div className={styles.appStoreLogo}>
          <img src={appStore} alt='app store' className={styles.appStoreIcon} />
          <Typography variant='h1-bold' className={styles.appStoreTitle}>
            {t('onboarding.voeryPersonalPlan.appStore.title')}
          </Typography>
          <div className={styles.appStoreLanguages}>
          <img src={languages} alt='languages' />

          </div>
        </div>

        <div className={styles.appStorePhone}>
          <img src={phone} alt='phone-voery-app' />
        </div>
      </div>
    </>
  );
};
